export default function ContactUs() {
    return (
        <div className="min-h-screen flex items-center justify-center bg-gray-100 dark:bg-gray-900 transition-colors">
            <div className="w-full max-w-md p-8 bg-white dark:bg-gray-800 rounded-lg shadow-lg">
                <h2 className="text-2xl font-bold mb-6 text-gray-900 dark:text-gray-100 text-center">
                    Contact Us
                </h2>
                <div className="mb-4">
                    <label className="block text-gray-700 dark:text-gray-300 font-semibold mb-1">
                        Email
                    </label>
                    <a
                        href="mailto:geradofashion@gmail.com"
                        className="text-blue-600 dark:text-blue-400 hover:underline break-all"
                    >
                        geradofashion@gmail.com
                    </a>
                </div>
                <div className="mb-4">
                    <label className="block text-gray-700 dark:text-gray-300 font-semibold mb-1">
                        Phone Number
                    </label>
                    <a
                        href="tel:+1234567890"
                        className="text-blue-600 dark:text-blue-400 hover:underline"
                    >
                        +91 9346306169
                    </a>
                </div>  
            </div>
        </div>
    );
}
